import { getTextFixed } from "../translations";
export const NRG_LASSEN = [
    [0, "NRG-las configurator", "configurator"]
];
export const parse = (row) => {
    const [_key, _description, _art] = row;
    const parsed = {
        key: _key,
        // wissel: undefined,
        // hoek: undefined,
        // profiel: undefined,
        // richting: undefined,
        // boogstraal: undefined,
        // teknrWissel: undefined,
        // teknrComp: undefined,
        artCodeTSNL: _art,
        aantal: 1,
        category: "nrglassen",
        _description,
        description() { return description(parsed); },
    };
    return parsed;
};
export const description = (row) => {
    return getTextFixed("NRG_LAS_CONFIGURATOR_TITLE");
};
